import { Fancybox, Panzoom } from "@fancyapps/ui"
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import "@fancyapps/ui/dist/panzoom/panzoom.css";
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { getSizedImageUrl } from '@shopify/theme-images';
import { sendEvent } from '../../../../scripts/global/utils/sendEvent';

const product = ({ product, variant, productType, variantsType, imageOrientation, sizeGuide, price, template }) => ({
  productTemplate: "",
  urlParams: "",
  variants: null,
  selectedVariant: null,
  selectedSwatch: null,
  currentProduct: null,
  selectedVariantDimensions: null,
  optionRadios: null,
  optionAllRadios: null,
  slider: null,
  selectedVariantImageID: 0,
  productGalleryContainer: null,
  showProductFullSpecs: false,
  productFullSpecsDrawerIsOpen: false,
  productOptionsContainer: null,
  selectedOptionsValuesId: [],
  unavailableVariants: null,
  unavailableOptionsValues: [],
  unavailableVariantsTitles: [],
  unavailableVariant: null,
  selectedOptionPosition: 0,
  hasDimensions: false,
  showStickyButton: false,
  showPopup: false,
  subscriptionModalOpen: false,
  thumbnailSlider: null,
  mainSlider: null,
  selectedPlan: "subsave",
  hasSellingPlan: false,
  sellingPlanId: null,
  selectedVariantSaleAllocationPrice: null,
  isPlaying: false,
  selectedOptions: [],
  checkedRadios: [],
  productContainer: null,
  activeSlideIndex: null,
  /*hidePauseButton: false,*/
  isAutoplay: false,
  selectedProductDetailsHeading: null,
  selectedProductDetailsContent: null,
  productDetailsDrawerIsOpen: false,
  selectedDetailIndex: 1,
  selectedImageModalIsOpen: false,
  selectedImage: null,
  panzoom:null,
  metaFieldObject: null,
  variantSizes: null,
  memberPrice: null,
  sizeDropdownIsOpen: false,
  isPhotography: false,
  variantsType: null,
  pathnameArray: null,
  isMobileDevice:false,
  tabIndex: null,
  currentBlockType: null,
  framesJSON: null,
  frames: [],
  imageOrientation: null,
  selectedFrame: null,
  imageSizes: null,
  selectedSize: null,
  selectedSizeHeight: null,
  biggestOption: false,
  activeIndex: null,
  videoContent: false,
  videoContainer: null,
  sizeGuideIsOpen: false,
  selectedFrameTypeSizes: null,
  selectedSizeGuideTab: "Mount",
  sizeGuideImages: null,
  currentProductImage: null,
  panzoomReady: false,
  transformed: false,
  drawer: null,
  drawerWrapper: null,
  bannerLabel: null,
  realIndex: 0,
  framedImage: false,
  setImages: [],
  setImageModalIsOpen: false,
  init() {
    if (document.querySelector("[data-frames]")){
      this.framesJSON = document.querySelector("[data-frames]").innerHTML
    }

    if (this.framesJSON){
      this.frames = JSON.parse(this.framesJSON).frames || []
    }

    this.videoContainer = document.querySelector(".video-container")

    this.imageOrientation = imageOrientation
    if (document.querySelector("[data-image-sizes]")){
      this.imageSizes = JSON.parse(document.querySelector("[data-image-sizes]").innerHTML)
    }

    this.isMobileDevice = window.innerWidth <= 990
    this.variantsType = variantsType
    this.isPhotography = productType === "Photography"

    this.productContainer = document.querySelector("[data-main-product]")
    window.setTimeout(()=>{
      this.optionAllRadios = [...document.querySelectorAll("[data-options]")]
      this.checkedRadios = this.optionAllRadios.filter((option) => option.checked)
      this.sectionId = this.productContainer.getAttribute('data-section-id')
      if (this.checkedRadios.length) {
        this.checkedRadios.forEach((radio) => {
          this.selectedOptions.push(radio.value)
        })
      }
    }, 0)

    const inStockContainer = document.querySelector("[data-form-container]")
    this.urlParams = new URL(window.location.href)
    this.currentProduct = product
    this.variants = product.variants

    /*this.currentProductImage = getSizedImageUrl(this.currentProduct.featured_image, `600x500`)*/



    this.pathnameArray = window.location.pathname.split('/')

    if (this.pathnameArray.length > 3){
      this.pathnameArray.length = this.pathnameArray.length-2
    }else{
      this.pathnameArray.length = this.pathnameArray.length-1
    }

    if (!this.isPhotography || variantsType === "simple" ){
      this.selectedVariant = variant
      this.drawURL()
    }

    if (this.isPhotography && this.urlParams.searchParams.get("variant")){
      this.selectedVariant = variant
    }

    if (this.selectedVariant && this.selectedVariant.featured_media) {
      this.selectedVariantImageID = this.selectedVariant.featured_media.id
    }

    if (!this.selectedVariant){

    }else{
      this.selectVariantFrame(this.selectedVariant)
    }

    this.productGalleryContainer = this.$refs.productGallery
    this.showStickyButton = this.isElementInViewport(inStockContainer)

    window.addEventListener("scroll", (event) => {

      if (inStockContainer) {
        this.showStickyButton = this.isElementInViewport(inStockContainer)
      }
    })

    window.addEventListener("resize", ()=>{
      this.isMobileDevice = window.innerWidth <= 990
    })

    window.addEventListener("keyup", (event)=>{
      if (event.key === "Escape"){
        this.closeImageModal()
        if (this.setImageModalIsOpen) {
          this.setImageModalIsOpen = false
          this.panzoom?.destroy()
        }
      }
    })

    this.$nextTick(() => {
      this.memberPrice = price
      if (this.mainSlider){
        window.mainSlider = this.mainSlider
        console.log("this.realIndex", this.realIndex)
        this.mainSlider.on("slideChange", (event) => {
          this.realIndex = event.realIndex
          this.toggleVideo(event)
          this.closeImageModal()
        })

        // The Intelligems experiment reveals the banner slide (lg:!hidden on
        // desktop) and enables this behaviour via the `_always_go_to_frame_on_selection`
        // flag. Both are applied asynchronously — after Swiper has already measured
        // the gallery, so its loop is built one slide short and forward navigation
        // can't reach the last image (backward works because the grid is only short
        // on the tail end). Because IG sets the flag async, checking it once in
        // init() misses it on a cold load (it only worked after an HMR refresh, when
        // the flag lingered on `window`). Poll until the experiment has both enabled
        // the flag and revealed the banner on desktop, then rebuild the loop once.
        // If the flag never arrives (control / experiment off) we simply give up.
        const rebuildGalleryLoop = () => {
          const s = this.mainSlider
          if (!s || s.destroyed) return
          if (s.params.loop){
            s.loopDestroy()
            s.loopCreate(s.realIndex)
          }
          s.update()
        }
        const bannerSlide = this.mainSlider.el.querySelector('.swiper-slide[class~="lg:!hidden"]')
        if (bannerSlide){
          let attempt = 0
          const armGalleryLoopRebuild = () => {
            if (
              window._always_go_to_frame_on_selection === true &&
              !this.isMobileDevice &&
              bannerSlide.offsetWidth > 0
            ){
              rebuildGalleryLoop()
            } else if (attempt++ < 30){
              window.setTimeout(armGalleryLoopRebuild, 100)
            }
          }
          armGalleryLoopRebuild()
        }

        if (template === "product.lifestyle-ab-test") {
          if (!this.isMobileDevice){
            this.mainSlider.removeSlide(0)
            this.mainSlider.updateSlides()
            this.mainSlider.slideToLoop(0, 0)
            this.mainSlider.update()
          }else{

          }
        }
      }

      this.unavailableVariants = this.variants.filter(variant => !variant.available)

      if (document.querySelector(".framed-image__slide")){
        this.selectedFrame = document.querySelector(".framed-image__slide").getAttribute("data-initial-frame")
        if (this.selectedFrame){
          this.setImageSizeAccordingSelectedFrame()
        }
      }
    })
    this.checkARModal()
    this.onOpenPostCodeChecker();

    if (this.isMobileDevice) this.sizeDropdownIsOpen = true;
  },
  getSelectedVariant(event, _, isDropdown, memberPrice) {

    this.selectedVariant = this.variants.filter((variant) => variant.title.trim().toLowerCase() === this.optionAllRadios.filter((radio) => { return radio.checked}).map((radio) => radio.value).join(" / ").trim().toLowerCase())[0]
    if (this.selectedVariant) {

      this.memberPrice = this.selectedVariant?.compare_at_price

      this.unavailableVariant = this.unavailableVariants.find((variant)=> this.selectedVariant.id === variant.id)

      if (this.selectedVariant.featured_media) {
        this.selectedVariantImageID = this.selectedVariant.featured_media.id
      }
      this.drawURL()
      this.lastSelectedVariantOptions = this.selectedVariant.options
      this.selectVariantFrame(this.selectedVariant)
    }else{
      this.selectVariantFrame(null)
    }
    if (this.currentProduct.options.length > 1) {
      this.setAvailableVariants(event)
    }

    if (!event.target.getAttribute("data-option-name").includes("Size")){
      this.setVariantsSizes(event)
    }

    if(this.mainSlider){
      const framedSlide = this.mainSlider.slides.find(slide => slide.classList.contains("framed-image__slide"))
      if(framedSlide){
        const mobileFramedSlide = framedSlide.getAttribute("data-swiper-slide-index")
        if(window._always_go_to_frame_on_selection === true){
          this.mainSlider.slideToLoop(mobileFramedSlide, 100)
        } else {
          this.mainSlider.slideToLoop(this.isMobileDevice ? mobileFramedSlide : 0, 100)
        }
      }
    }
  },
  selectSwatch(object){
    const { product, variant } = object
    this.currentProduct = product
    this.variants = product.variants
    this.selectedVariant = variant
    this.fetchProduct(this.currentProduct, this.selectedVariant).then()
    if (this.mainSlider){
      this.mainSlider.update()
    }

    if (this.pathnameArray.join('/').includes("collections")){
      history.replaceState({}, "handle", `${this.pathnameArray.join('/')}` + `/products/${this.currentProduct.handle}/?variant=${this.selectedVariant.id}`);
    }else{
      history.replaceState({}, "handle", `${this.pathnameArray.join('/')}` + `/${this.currentProduct.handle}/?variant=${this.selectedVariant.id}`);
    }

    //this.drawURL()
  },
  async fetchProduct(product, variant){
    this.isLoading = true
    let fetchURL = ""

    if (this.pathnameArray.join('/').includes("collections") && !this.pathnameArray.join('/').includes("products")){
      fetchURL = `${this.pathnameArray.join('/')}/products/${product.handle}?section_id=${this.sectionId}`
    }else{
      fetchURL = `${this.pathnameArray.join('/')}/${product.handle}?section_id=${this.sectionId}`
    }

    await fetch(`${fetchURL}`)
      .then(res=>res.text())
      .then(data=>{
        const parsed = new DOMParser().parseFromString(data, 'text/html')
        this.productContainer.innerHTML = parsed.querySelector('[data-main-product]').innerHTML
        this.isLoading = false
        //this.fetchWishlist(variant, this)
        /*window.SwymCallbacks.push(() => {
          const swymWishlistButtons = document.querySelector(".wishlist-button")
          _swat.evtLayer.addEventListener(_swat.JSEvents.addedToWishlist, (event) => {
            this.isVariantInWishlist = event.detail.d.epi === this.selectedVariant.id
            this.fetchWishlist(this.selectedVariant, this)
          });
          this.fetchWishlist(this.selectedVariant, this)

          if (swymWishlistButtons){
            //swymWishlistButtons.addEventListener("click", ()=>this.removeFromWishlist(this))
            swymWishlistButtons.addEventListener("click", (event)=>this.handleButtonClick(this))
          }
        })*/
      })
  },
  setVariantsSizes(event){
    let optionName
    if (event.target.value !== "No Frame" && event.target.value !== "Full Bleed"){
      optionName = event.target.getAttribute("data-option-name")
    }else if(event.target.value === "No Frame" || event.target.value === "Full Bleed"){
      optionName = event.target.value
    }

    this.variantSizes = this.variantSizes = this.metaFieldObject?.[optionName] ?? null;
  },
  setAvailableVariants(event) {
    this.optionAllRadios.forEach((radio) => {radio.disabled = false})
    this.checkedRadios = this.optionAllRadios.filter((option) => option.checked)

    if (event.target.value === "No Frame" || this.checkedRadios.filter(radio => radio.value === "No Frame").length > 0) {
      this.optionAllRadios.filter(radio => radio.value === "Border")[0].click()
      this.optionAllRadios.filter(radio => radio.value === "Full Bleed")[0].disabled = true
    }
  },
  switchSizeGuideTabs(event) {
    this.selectedSizeGuideTab = event.target.value
    this.selectedFrameTypeSizes = this.metaFieldObject[this.selectedSizeGuideTab]
    this.sizeGuideImages = sizeGuide.filter(item => item.mount === this.selectedSizeGuideTab).filter(filteredItem => filteredItem.image_orientation.toLowerCase() === this.imageOrientation)[0]
  },
  openSizeGuideDrawer(){
    this.sizeGuideIsOpen = true
    document.querySelector("body").classList.add("modal__open")
    document.querySelector("html").classList.add("modal__open")
  },
  closeSizeGuideDrawer(){
    this.sizeGuideIsOpen = false
    document.querySelector("body").classList.remove("modal__open")
    document.querySelector("html").classList.remove("modal__open")
  },
  slideToSelectedVariantImage(id) {
    // this.mainSlider.slideTo(0, 100, null)
    /*if (this.productGalleryContainer && this.productGalleryContainer.querySelector(`[data-image-id="${id}"]`)) {
      this.selectedIndex = this.productGalleryContainer
        .querySelector(`[data-image-id="${id}"]`)
        .getAttribute("data-slide-index")
      if (this.mainSlider){
        this.mainSlider.slideTo(this.selectedIndex, 100, null)
      }
    }*/
  },
  selectVariantFrame(variant){

    if (!variant){
      const checkedRadios = this.optionAllRadios?.filter((radio) => {return radio.checked})
      const optionArray = checkedRadios.map(item => item.value)
      optionArray.unshift(this.imageOrientation)
      optionArray.splice(1, 0, 'Small');

      const initHandle = optionArray.map(item => item.trim().toLowerCase().split(" ").join("-")).join("-");
      const options = initHandle.split("-")

      this.frames.forEach(frame => {
        if (options.length === Object.keys(frame)[0].split("-").length && options.every((item) => Object.keys(frame)[0].split("-").includes(item))){
          this.selectedFrame = frame[`${Object.keys(frame)[0]}`]
          document.documentElement.style.setProperty("--frame",`url(${this.selectedFrame})`)
        }
      })
    }else{
      const optionHandle = this.imageOrientation + "-" + variant?.options.map(option => option.trim().toLowerCase().split(" ").join("-")).join("-")
      const variantOptions = optionHandle.split("-")
      if (variantOptions.length < 4){
        variantOptions.push("border")
      }

      if (variantOptions.length){
        this.frames.forEach(frame => {
          if (variantOptions.length === Object.keys(frame)[0].split("-").length && variantOptions.every((item) => Object.keys(frame)[0].split("-").includes(item))) {
            this.selectedFrame = frame[`${Object.keys(frame)[0]}`]
            document.documentElement.style.setProperty("--frame", `url(${this.selectedFrame})`)
          }
        })
      }
    }

    if (this.selectedFrame){
      window.setTimeout(()=>{
        this.setImageSizeAccordingSelectedFrame()
      }, 0)
    }
  },
  setImageSizeAccordingSelectedFrame(){
    if (this.selectedVariant){
      this.selectedVariant.options.forEach(option => {
        if (!this.imageSizes[`${this.imageOrientation}`][option]){
          option = "Border"
        }
        if (this.imageSizes[`${this.imageOrientation}`][option]){
          const sizes = this.imageSizes[`${this.imageOrientation}`][option]
          this.selectedVariant.options.forEach(option => {
            if (sizes[option.toLowerCase()]){

              const tableSize = sizes[option.toLowerCase()];

              this.selectedSize = tableSize["width"]
              this.selectedSizeHeight = tableSize["height"]

              this.biggestOption = !!tableSize?.biggest;

              /*document.documentElement.style.setProperty("--image-width", this.selectedSize)
              document.documentElement.style.setProperty("--image-height", this.selectedSizeHeight)*/
            }
          })
        }
      })
    } else {
      const checkedRadios = this.optionAllRadios?.filter((radio) => {return radio.checked})
      if (checkedRadios && checkedRadios.length >= 2) {
        const selectedFrameOption = checkedRadios.find(radio => radio.getAttribute("data-option-name") === "Frame")?.value || "Border"
        const selectedMountOption = checkedRadios.find(radio => radio.getAttribute("data-option-name") === "Mount")?.value || "Border"
        const defaultSize = "Small"

        let frameOption = selectedFrameOption
        if (!this.imageSizes[`${this.imageOrientation}`][frameOption]){
          frameOption = "Border"
        }

        if (this.imageSizes[`${this.imageOrientation}`][frameOption]){
          const sizes = this.imageSizes[`${this.imageOrientation}`][frameOption]
          if (sizes[defaultSize.toLowerCase()]){
            const tableSize = sizes[defaultSize.toLowerCase()];
            this.selectedSize = tableSize["width"]
            this.selectedSizeHeight = tableSize["height"]
            this.biggestOption = !!tableSize?.biggest;
          }
        }
      }
    }
  },
  drawURL() {
    if (this.selectedVariant){
      this.urlParams.searchParams.set("variant", this.selectedVariant.id)
      history.replaceState(this.selectedVariant.id, "variant", this.urlParams)
    }
  },
  isElementInViewport(el) {
    if (!el) return
    const rect = el.getBoundingClientRect();
    return (
      rect.top + el.clientHeight < 0
    );
  },
  toggleVideo(event) {
    let index_currentSlide = event.realIndex
    let currentSlide = event.slides[index_currentSlide]
    if (currentSlide){
      let videoContainer = currentSlide.querySelector(".video-container")
      let playButton = currentSlide.querySelector("button")

      if (videoContainer) {
        this.stopVideo()
        if (this.isAutoplay) {
          this.playVideo(playButton, index_currentSlide)
        }
      }
    }
  },
  playVideo() {
    const videoContainer = document.querySelectorAll(".video-container")
    videoContainer.forEach((container) => {
        if (container.querySelector("video")){
            container.querySelector("video").play()
        }
    })
    this.isPlaying = true
   /* this.showPauseButton(index)
    this.hidePlayButton(index)*/
  },
  pauseVideo($el, index) {
    const videoContainer = document.querySelectorAll(`[data-slide-index="${index}"]`)
    videoContainer.forEach((container) => {
        if (container.querySelector("video")){
            container.querySelector("video").pause()
        }
    })
    this.isPlaying = false
    this.hidePauseButton(index)
    this.showPlayButton(index)
  },
  stopVideo(index){
      this.isPlaying = false
      const video = this.productContainer.querySelectorAll("video")
      if (video.length) {
        video.forEach(vid => {
          vid.pause()
          // vid.currentTime = 0
        })
      }
      const playButtons = this.productContainer.querySelectorAll("[data-play-button]")
      const pauseButtons = this.productContainer.querySelectorAll("[data-pause-button]")
      if (playButtons){
        playButtons.forEach((button)=>{
          button.classList.remove("!hidden")
        })
      }

      if (pauseButtons){
        pauseButtons.forEach((button)=>{
          button.classList.add("!hidden")
        })
      }
    },
  hidePauseButton(index) {
    const pauseButtons = this.productContainer.querySelectorAll(
      `[data-pause-index="${index}"]`
    )
    if (pauseButtons.length) {
      pauseButtons.forEach((pauseButton) => {
        pauseButton.classList.add("!hidden")

        setTimeout(() => {
          pauseButton.classList.add("opacity-0")
        }, 1000)
      })
    }
  },
  showPauseButton(index) {
    const pauseButtons = this.productContainer.querySelectorAll(
      `[data-pause-index="${index}"]`
    )
    const playButtons = this.productContainer.querySelectorAll(
      `[data-play-index="${index}"]`
    )

    if (pauseButtons.length) {
      pauseButtons.forEach((pauseButton) => {
        pauseButton.classList.remove("!hidden")

        setTimeout(() => {
          pauseButton.classList.remove("opacity-0")
        }, 1000)
      })
    }
  },
  showPlayButton(index) {
    const playButtons = this.productContainer.querySelectorAll(
      `[data-play-index="${index}"]`
    )

    if (playButtons.length) {
      playButtons.forEach((playButton) => {
        playButton.classList.remove("!hidden")
      })
    }
  },
  hidePlayButton(index) {
    const playButtons = this.productContainer.querySelectorAll(
      `[data-play-index="${index}"]`
    )

    if (playButtons.length) {
      playButtons.forEach((playButton) => {
        playButton.classList.add("!hidden")
      })
    }
  },
  openDetailsDrawer(object, inDrawer, index = 0, tabIndex, blockType){
    document.querySelector("body").classList.add("modal__open")
    document.querySelector("html").classList.add("modal__open")
    this.selectedDetailIndex = index
    this.currentBlockType = blockType

    this.selectedProductDetailsHeading = object.heading
    this.selectedProductDetailsContent = object.content

    this.tabIndex = tabIndex

    if (inDrawer === "false"){
      setTimeout(()=>{
        this.productDetailsDrawerIsOpen = true
      }, 300)
    }
  },
  closeDetailsDrawer(object){
    document.querySelector("body").classList.remove("modal__open")
    document.querySelector("html").classList.remove("modal__open")
    this.productDetailsDrawerIsOpen = false
  },
  zoomImage(image, index, videContent, clickedSlide, isVideo = false){

    if (isVideo){
      if (this.isPlaying){
         this.stopVideo();
      } else {
      this.playVideo();
      }

      return null;
    }

    this.framedImage = clickedSlide && clickedSlide.classList.contains("framed-image__slide");

    this.videoContent = videContent
    this.activeIndex = index
    this.selectedImageModalIsOpen = true
    this.selectedImage = image

    this.setImageSizeAccordingSelectedFrame()
  
    if (!videContent){
      this.$nextTick(() => {
        this.initPanZoom(index)
      })
    }else{
      this.stopVideo()
    }
  },

  zoomImageSet(imagesArray, clickedIndex, clickedSlide){
     console.log('Set images:', imagesArray)
    
    this.setImages = imagesArray
    this.framedImage = clickedSlide && clickedSlide.classList.contains("framed-image__slide");
    
    this.setImageSizeAccordingSelectedFrame()
    
    this.setImageModalIsOpen = true
  },
  initSetZoom(){
   
    if (this.panzoom) {
      this.panzoom.destroy();
      this.panzoom = null;
    }
   
    this.$nextTick(() => {
      setTimeout(() => {
        console.log('Initializing panzoom for sets')
        this.transformed = false
        const container = document.getElementById("setZoomContainer");
        const image = container?.querySelector(".product-image-gallery__wrapper")
        
        if (!container || !image) {
          console.log('Container or image not found')
          return;
        }
        
        if (image){
          image.style.transform = "matrix(1, 0, 0, 1, 0, 0)"
        }

        const options = {
          classes: {
            content: "product-image-gallery__wrapper"
          },
          maxScale: 4,
          minScale: 1,
          spinner: false,
          zoom: true,
          panOnlyWhenZoomed: false,
          transformParent: false,
          click: "toggleMax",
          on: {
            ready: ()=>{
              console.log('Panzoom ready')
              this.transformed = true
            }
          } 
        }
        
        this.panzoom = new Panzoom(container, options);
        console.log('Panzoom initialized for sets', this.panzoom)
      }, 150)
    })
  },
  closeImageModal(){
    this.selectedImageModalIsOpen = false
    this.playVideo()
  },
  initPanZoom(index){
    this.transformed = false
    const container = document.getElementById("myPanzoom");
    const image = container?.querySelector(".product-image-gallery__wrapper")
    if (image){
      image.style.transform = "matrix(1, 0, 0, 1, 0, 0)"
    }

    const options = {
      classes: {
        content: "modal-image"
      },
      maxScale: 4,
      minScale: 1,
      spinner: false,
      zoom: true,
      transformParent: true,
      click: "toggleMax",
      on: {
        ready: ()=>{
          this.transformed = true
        }
      }
    }
    this.panzoom?.destroy();
    this.panzoom = new Panzoom(container, options);
    sendEvent('PDP - Gallery Zoom', { event_detail: index + 1 });
  },
  toggleSizesDropdown(type = 'popup'){
    this.sizeDropdownIsOpen = !this.sizeDropdownIsOpen

    if (window.innerWidth <= 990){
      if (type === 'popup-mobile') {
        return null;
      }

      if( type === "dropdown"){
        disableBodyScroll(this.drawerWrapper, {
          reserveScrollBarGap: true
        });
      }else{
        disableBodyScroll(this.drawerWrapper, {
          reserveScrollBarGap: true,
          allowTouchMove: el => {
            while (el && el !== document.body) {
              if (el.getAttribute('body-scroll-lock-ignore') !== null) {
                return true;
              }

              el = el.parentElement;
            }
          }
        });
      }
      disableBodyScroll(this.drawerWrapper, {
        reserveScrollBarGap: true,
       allowTouchMove: el => {
          while (el && el !== document.body) {
            if (el.getAttribute('body-scroll-lock-ignore') !== null) {
              return true;
            }

            el = el.parentElement;
          }
        }
      });
     /* document.querySelector("body").style.overflow = "hidden"
      document.querySelector("html").style.overflow = "hidden"
      document.querySelector("html").style.maxHeight = "100dvh"*/
    }
  },
  closeSizesDropdown(){
    this.sizeDropdownIsOpen = false
    if (window.innerWidth <= 990){
      enableBodyScroll(this.drawerWrapper);
      /*document.querySelector("body").style.overflow = ""
      document.querySelector("html").style.overflow = ""
      document.querySelector("body").style.maxHeight = ""*/
    }
  },
  checkARModal() {
    const isOpenAR = window.location.hash.includes('open-ar=true');
    if (isOpenAR && this.isMobile()) {

      const templateID = `product-card-ar-modal-${this.currentProduct.id}`

      window.dispatchEvent(new CustomEvent("mobileDrawerOpen", {
          detail:
            {
              templateId: templateID
            },
        }),
      )

    }
  },
  onOpenPostCodeChecker() {
    const buttons = [...document.querySelectorAll('[data-js-open-postcode-checker]')];
    if (buttons.length) {
      buttons.forEach(button => {
        button.addEventListener('click', this.openPostCodeChecker.bind(this));
      });
    }
  },
  openPostCodeChecker(e) {
    e.preventDefault();
    const container = e.currentTarget?.closest("[data-js-container-postcode-checker]") || null;
    const popup = container?.querySelector("[data-js-postcode-popup]") || null;

    if (!container || !popup) {
      return null;
    }


    popup.classList.toggle("hidden");


    if (!popup.classList.contains("hidden")) {

      this.outsideClickHandler = (event) => {

        if (!popup.classList.contains('hidden') && !container.contains(event.target)) {
          popup.classList.add('hidden');

          document.removeEventListener('click', this.outsideClickHandler);
        }
      };

      setTimeout(() => {
        document.addEventListener('click', this.outsideClickHandler);
      }, 0);
    }
},
  closeMobileDrawer() {
    window.dispatchEvent(new Event('close-drawer'));
    enableBodyScroll(this.drawerWrapper);
    this.removeDrawerEventListener();
    /*document.querySelector("body").style.overflow = ""
    document.querySelector("html").style.overflow = ""
    document.querySelector("html").style.maxHeight = ""*/
  },
  setDrawerListeners() {
    this.drawer = this.$el;
    this.drawerWrapper = this.drawer;
    const bottomSheetHandle = this.drawer.querySelector('.product-options__mobile-header');
    if (bottomSheetHandle && this.drawerWrapper) {
      this.onTouchStart = this.onTouchStart.bind(this);
      this.onTouchMove = this.onTouchMove.bind(this);
      this.onTouchEnd = this.onTouchEnd.bind(this);

      bottomSheetHandle.addEventListener('touchstart', this.onTouchStart);
      document.addEventListener('touchmove', this.onTouchMove);
      document.addEventListener('touchend', this.onTouchEnd);
    }
  },
  onTouchStart(event) {
    this.startDrag(event, event.touches[0].clientY);
  },
  onTouchMove(event) {
    this.drag(event, event.touches[0].clientY);
  },
  onTouchEnd(event) {
    this.endDrag(event, event.changedTouches[0].clientY);
  },
  startDrag(event, clientY) {
    this.isDragging = true;
    this.startY = clientY;
    const style = window.getComputedStyle(this.drawer);
    const matrix = new DOMMatrixReadOnly(style.transform);
    this.initialTranslateY = matrix.m42;
    this.drawer.classList.add('is-dragging');
  },
  drag(event, clientY) {

    if (!this.isDragging) {
      return null;
    }

    const deltaY = clientY - this.startY;
    const newTranslateY = Math.max(this.initialTranslateY + deltaY, 0);
    this.drawerWrapper.style.transform = `translateY(${newTranslateY}px)`;

  },
  endDrag(event, clientY) {

    if (!this.isDragging) {
      return null;
    }

    const deltaY = clientY - this.startY;

    this.drawer.classList.remove('is-dragging');
    this.drawerWrapper.style.transform = '';

    if (deltaY > 80) {
      this.closeMobileDrawer();
      this.removeDrawerEventListener();
    }


    this.isDragging = false;
  },
  removeDrawerEventListener() {
    document.removeEventListener('touchmove', this.onTouchMove);
    document.removeEventListener('touchend', this.onTouchEnd);
  },
  isMobile() {
    return /iPhone|iPod|iPad|Android/i.test(navigator.userAgent)
  }
})



export default product

window.addEventListener("alpine:init", () => {
  Alpine.data("mainProduct", product)
})
